import { TypePolicy } from '@apollo/client';

export const contentSourceTypePolicy: TypePolicy = {
  fields: {
    defaultRights: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
    rightsMappings: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
  },
};
